import _ from 'lodash'
import {
  shouldRedact,
  truncateRequestBody,
  truncateResponseBody,
  isReadRequest,
  stripAuthHeader,
  MAX_BODY_REQUEST,
  MAX_BODY_RESPONSE,
  networkRateLimiter,
} from './redaction-rules'
import { getErrorMessage } from '../errors'

export function responseSanitizer(response) {

  if (shouldRedact(response.url)) {
    return null
  }

  const bodyLength = _.get(response, 'body.length', 0)
  if (bodyLength > MAX_BODY_RESPONSE) {
    try {
      console.log(`Truncating response payload of ${response.body?.length} for ${response.url}`)
      // A slow operation, but at least memory resident
      return {
        ...response,
        body: truncateResponseBody(response.body),
      }
    } catch (err) {
      console.log(`Failed to parse request body: ${getErrorMessage(err)}`)
      return {
        ...response,
        body: null,
      }
    }
  }
  return response
}

export function requestSanitizer(request) {
  try {

    if (shouldRedact(request.url)) {
      return null
    }

    // Only rate-limit "read" requests like queries or fetches.
    // "Write" requests are important, so we don't rate-limit them.
    const isRead = isReadRequest(request)
    if (isRead && !networkRateLimiter()) {
      // Drop read requests that exceed the rate limit
      return null
    }

    stripAuthHeader(request.headers)

    const bodyLength = _.get(request, 'body.length', 0)
    if (bodyLength >= MAX_BODY_REQUEST) {
      console.log(
        `Truncating request payload of ${request.body?.length} for ${request.method}:${request.url}`
      )
      // This might take a while
      return {
        ...request,
        body: truncateRequestBody(request.body, request.method),
      }
    }

    return request
  } catch (e) {
    console.log(`Failed to parse request body: ${getErrorMessage(e)}`)
    // There may still be a password in there
    return {
      ...request,
      body: null,
    }
  }
}
